import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { MyUtils } from 'src/app/services/my-utils.service';
import { InputFormModel } from '../models/input-form';

@Component({
  selector: 'app-generate-autocomplete-input',
  templateUrl: './generate-autocomplete-input.component.html',
  styleUrls: ['./generate-autocomplete-input.component.scss']
})
export class GenerateAutocompleteInputComponent implements OnInit {
  @Input() item!: InputFormModel;
  @Input() form!: FormGroup;
  @Input() appearanceForm!: string | undefined;
  stateCtrl = new FormControl();;
  groups: any;
  formName: any;
  groupsBK: any;
  auto = true;
  appearance: MatFormFieldAppearance = 'fill' as MatFormFieldAppearance;
  isEnhanced = false;
  constructor(private cdref: ChangeDetectorRef, public utils: MyUtils) { }

  ngOnInit() {
    this.appearance = this.appearanceForm as MatFormFieldAppearance;
    this.groups = this.item?.objectSelect;
    this.groupsBK = this.groups;
    this.formName = this.item?.formControlName;
    // this.stateCtrl.setValue(this.form.controls[this.formName].value ? this.form.controls[this.formName].value[this.item!['viewValueSelect']!] : '')
    this.stateCtrl.valueChanges.subscribe(value => {
      this.isEnhanced = value !== '' ? true : false;

      this._filter(value)
    }

    );
    this.stateCtrl.setValidators(this.form.controls[this.formName].validator)


    this.form.valueChanges.subscribe(data => {
    })
    // this.form.valueChanges.subscribe(data => this.stateCtrl.setValue(data[this.item!['viewValueSelect']!]))
  }



  ngAfterContentChecked() {

    this.cdref.detectChanges();
  }


  private _filter(name: any) {
    if (typeof name === 'string') {
      const filterValue = name.toLowerCase();
      this.groups = this.groupsBK.filter((option: any) =>
        option[this.item!['viewValueSelect']!].toLowerCase().includes(filterValue));
    }

  }

  updateMySelection(element: any, e: any) {

    this.form.controls[this.formName].setValue(element);
  }
  clear() {
    this.stateCtrl.setValue('');
    this.form.controls[this.formName].setValue(undefined);
  }
}
